import { useState, useEffect } from 'react'

const useOrientation = () => {
  const portraitMediaQuery = window.matchMedia('(orientation: portrait)')

  const [isPortrait, setIsPortrait] = useState(portraitMediaQuery.matches)

  useEffect(() => {
    const handleChange = () => setIsPortrait(portraitMediaQuery.matches)
    portraitMediaQuery.addEventListener('change', handleChange)

    return () => portraitMediaQuery.removeEventListener('change', handleChange)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { isPortrait }
}

export default useOrientation
